import { Trans } from '@lingui/react/macro';

import { Button, LinkButton } from '@/components/buttons';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { ReturnToLink } from '@/components/ReturnToLink';
import { ROUTES } from '@/router';

type Props = {
  isSaving: boolean;
};

const UserInviteHeader = ({ isSaving }: Props) => {
  return (
    <div className="flex items-center justify-between">
      <ReturnToLink route={ROUTES.users.path} routeName={<Trans>Users & Roles</Trans>} />
      <div className="flex items-center gap-4">
        <PendoPlaceholder />
        <LinkButton to={ROUTES.users.path} disabled={isSaving}>
          <Trans>Cancel</Trans>
        </LinkButton>
        <Button variant="primary" type="submit" isLoading={isSaving}>
          <Trans>Invite User</Trans>
        </Button>
      </div>
    </div>
  );
};

export default UserInviteHeader;
